import React, { createContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    const [user, setUser] = useState(null);
    const [nom, setNom] = useState(null);
    const [curso, setCurso] = useState(null);
    const [initializing, setInitializing] = useState(true);

    // Cargar desde localStorage al iniciar
    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        const storedUser = localStorage.getItem('user');
        const storedNom = localStorage.getItem('nom');
        const storedCurso = localStorage.getItem('curso');

        if (storedToken) setToken(storedToken);
        if (storedUser) {
            try { setUser(JSON.parse(storedUser)); } catch { localStorage.removeItem('user'); }
        }
        if (storedNom) setNom(storedNom);
        if (storedCurso) setCurso(storedCurso);
        setInitializing(false);
    }, []);

    // Login y almacenamiento
    const login = (jwtToken, username) => {
        const userData = { username };
        const currentHost = window.location.hostname; // ejemplo: asistentelegalcl.botvirtualia.com

        setToken(jwtToken);
        setUser(userData);
        setNom(username);
        setCurso(currentHost);

        localStorage.setItem('token', jwtToken);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('nom', username);
        localStorage.setItem('curso', currentHost);
    };

    // Logout y limpieza
    const logout = () => {
        setToken(null);
        setUser(null);
        setNom(null);
        setCurso(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('nom');
        localStorage.removeItem('curso');
    };

    const auth = !!token;

    return (
        <AuthContext.Provider value={{
            auth,
            initializing,
            token,
            user,
            login,
            logout,
            nom,
            setNom,
            curso,
            setCurso
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext, AuthProvider };
